import * as XLSX from "xlsx";

export const exportTasksToExcel = (tasks = []) => {
  try {
    const taskPagePath = window.location.pathname || "/tasks";
    const headerRow = [
      "ID",
      "Title",
      "Status",
      "Owner",
      "Domain",
      "Regodit Task Link",
    ];

    const exportData = [headerRow];

    tasks.forEach((task) => {
      exportData.push([
        task?.id ?? "-",
        task?.title || "-",
        task?.status_title || task?.status_key || "-",
        task?.task_owner_data?.name || task?.task_owner_data?.email || "Unassigned",
        task?.domains?.map((d) => d?.title || d?.key).filter(Boolean).join(", ") || "-",
        task?.id
          ? `${window.location.origin}${taskPagePath}?taskId=${task.id}`
          : "-",
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    // Make Regodit Task Link cells true Excel hyperlinks.
    for (let row = 1; row < exportData.length; row += 1) {
      const linkValue = exportData[row][5];
      if (typeof linkValue === "string" && linkValue.startsWith("http")) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: 5 });
        if (ws[cellAddress]) {
          ws[cellAddress].l = { Target: linkValue };
        }
      }
    }
    ws["!cols"] = [
      { wch: 8 },
      { wch: 45 },
      { wch: 16 },
      { wch: 28 },
      { wch: 26 },
      { wch: 60 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tasks");

    const date = new Date().toISOString().split("T")[0];
    XLSX.writeFile(wb, `Tasks_${date}.xlsx`);

    return { success: true };
  } catch (error) {
    console.error("Task export failed:", error);
    return { success: false, error };
  }
};

